import * as DashboardConstants from "../../constants/DashboardConstants";
import {prepareChartData} from "./HighChartsDrawer";
import {calcChartTitle} from "./HighGaugeDrawer";
import {handleChartClick} from "./HighPieChartDrawer";

/**
 *
 * @param {namaTypes.DTOUserDashbordChartLine} userDashboardChartLine
 * @param h
 * @param w
 * @return {JQuery | jQuery | HTMLElement}
 */
export function createHighStackedAndGroupedColumn(userDashboardChartLine, h, w, widget, Highcharts) {
    let params = userDashboardChartLine.parameters;
    let yAxisTitle = params[DashboardConstants.Param_Title];
    let stackAndGroupedColData = userDashboardChartLine.stackAndGroupedColData;
    let chartTitle = calcChartTitle(userDashboardChartLine);
    let widgetId = widget.attr('id');
    let chartData = {
        type: 'column'
    };
    chartData = prepareChartData(chartData, w, h);
    Highcharts.chart(widgetId, {
        chart: chartData,
        xAxis: {
            categories: stackAndGroupedColData.categories
        },
        yAxis: {
            allowDecimals: false,
            min: 0,
            title: {
                text: yAxisTitle
            }
        },
        tooltip: {
            formatter: function () {
                return '<b>' + this.x + '</b><br/>' +
                    this.series.name + ': ' + this.y + '<br/>' +
                    'Total: ' + this.point.stackTotal;
            }
        },
        plotOptions: {
            column: {
                stacking: 'normal',
                point: {
                    events: {
                        click: handleChartClick
                    }
                }
            }
        },

        series: stackAndGroupedColData.data
    });
}